import { Suspense, lazy, useEffect, useState } from "react";
import { useAppStateStore } from "@/stores/useAppState";

// Defer loading the LoginModal bundle until the modal first opens.
// Why: LoginModal pulls in framer-motion, social-provider hooks, IZIWebCheckout,
// and the auth flow — none of which we need on first paint.
const LoginModal = lazy(() => import("./LoginModal"));

const LoginModalGate = () => {
  const [hasEverOpened, setHasEverOpened] = useState(false);
  const isOpen = useAppStateStore((s) => s.loginModal.isOpen);

  useEffect(() => {
    if (isOpen) setHasEverOpened(true);
  }, [isOpen]);

  if (!hasEverOpened) return null;

  return (
    <Suspense fallback={null}>
      <LoginModal />
    </Suspense>
  );
};

export default LoginModalGate;
